// extracted by mini-css-extract-plugin
export var active = "_er-7";
export var container = "_er-0";
export var evenWidth = "_er-4";
export var large = "_er-5";
export var outlet = "_er-8";
export var slide = "_er-2";
export var small = "_er-6";
export var tab = "_er-3";
export var tabs = "_er-1";